export default __webpack_public_path__ + "static/media/TTT_logo.aec78895.png";